// @flow

import {ApiClient} from 'docs/data';
import {accountLoading, accountLoaded} from 'docs/data/account/AccountReducer';
import {transformAccount, transformNavigation} from 'docs/server/transformers';

import type {Locale, Dispatcher} from 'docs/data';
import type {AccountEvent} from 'docs/data/account/AccountReducer';

export const setLocale = (
  api: ApiClient,
  dispatch: Dispatcher<AccountEvent>,
) => async (locale: Locale, setNavigation: any) => {
  dispatch(accountLoading());

  const response = await api.saveAccountSettings({
    country: undefined,
    locale: locale.code,
  });

  const account = transformAccount(response.account);
  const navigation = transformNavigation(response.navigation);

  // TODO (nkohari): This should be an action which is dispatched
  setNavigation(navigation);

  dispatch(accountLoaded(account));
};
